class StandingsService {
    constructor(sportsManager) {
        this.standing = null;
        this.sportsManager = sportsManager
        this.jsonManager = this.sportsManager.jsonManager;
        this.eventManager = this.sportsManager.eventManager;      
    }
    async getStandings(eventName,sportsId, tourId, status,jsonConfig) {
        this.jsonManager.fetchJSONData(sportsId, tourId, status, "all", jsonConfig).then(standingData => {
            const standingWidgetData = standingData?.standings?.groups || []; 
            const standingsMetaData = standingData?.standings?.series_metadata || {};  
            this.eventManager.broadcastPrivateEvent(eventName, { standingWidgetData, standingsMetaData });
        })
    }
    fetchStandingsData(eventName, sportsId, tourId, status, jsonConfig) {
        this.getStandings(eventName,sportsId, tourId, status, jsonConfig)
    }
}

export default StandingsService;
